<template>
  <div>
    <div class="preUser expand">
      <div class="preUser-left">
        <div class="content-login registerLogin">
          <b-link to="/" style="width: fit-content">
            <img class="logo" src="@/assets/img/logo-login.png" alt="" />
          </b-link>
          <b-form class="Login">
            <div class="body">
              <div class="header-title-between">
                <div>
                  <span>Plataforma de Estudiantes</span>
                  <h4>Registro</h4>
                </div>
                <div class="back-step mt-0" @click="backStep">
                  <icon name="arrow-left" />
                  Regresar
                </div>
              </div>
              <div>
                <b-row class="mb-4 content-register">
                  <b-col>
                    <div class="content-photo">
                      <b-avatar
                        variant="info"
                        class="mb-3"
                        size="145px"
                        :src="urlPhoto"
                        style="background: #b7b8bd"
                      ></b-avatar>
                      <input
                        type="file"
                        ref="file"
                        style="display: none"
                        accept="image/*"
                        @change="handleFile"
                      />
                      <b-button
                        class="btn btn-primary d-block m-auto"
                        @click="$refs.file.click()"
                        ><icon name="cloud-file-2" />Subir foto</b-button
                      >
                      <!-- <b-avatar variant="success" icon="people-fill"></b-avatar> -->
                    </div>
                  </b-col>
                  <b-col sm="12" xl="12" cols="12" style="max-width: 760px">
                    <b-row class="account-data">
                      <b-col cols="12" md="7">
                        <b-form-row>
                          <b-col md="5">
                            <b-form-group
                              id="input-firstname-title"
                              label="Nombre"
                            >
                              <b-form-input
                                id="input-firstname"
                                v-model="form.user.firstName"
                                required
                                v-bind:class="{
                                  error: $v.form.user.firstName.$error,
                                }"
                                @blur="$v.form.user.firstName.$touch()"
                              ></b-form-input>
                              <span class="error-input d-block">{{
                                validationMsgRegistro($v.form.user.firstName)
                              }}</span>
                            </b-form-group>
                          </b-col>
                          <b-col md="7">
                            <b-form-group
                              id="input-lastname-title"
                              label="Apellidos"
                            >
                              <b-form-input
                                id="input-lastname"
                                v-model="form.user.lastName"
                                required
                                v-bind:class="{
                                  error: $v.form.user.lastName.$error,
                                }"
                                @blur="$v.form.user.lastName.$touch()"
                              ></b-form-input>
                              <span class="error-input d-block">{{
                                validationMsgRegistro($v.form.user.lastName)
                              }}</span>
                            </b-form-group>
                          </b-col>
                        </b-form-row>
                        <b-form-group id="input-fecha-nacimiento-title">
                          <p class="d-flex align-items-center bold">
                            Fecha de Nacimiento (Estudiante)<span
                              id="tooltip1"
                              class="ml-2 icon-info"
                              ><icon name="info"
                            /></span>
                          </p>
                          <b-tooltip target="tooltip1" placement="bottom"
                            >Colocar la fecha de nacimiento del estudiante ya
                            que los cursos sugeridos varían según la
                            edad.</b-tooltip
                          >
                          <!-- <b-form-input id="input-fecha-nacimiento" style="width: 410px;" type="date" v-model="form.user.dob" :placeholder="$t('my-account.EnterDateBirth')"
                                                    required v-bind:class="{ error: $v.form.user.dob.$error}" @blur="$v.form.user.dob.$touch()"
                                                ></b-form-input> -->
                          <b-input-group class="datepicker-group">
                            <b-form-input
                              v-model="form.user.dob"
                              @blur="$v.form.user.dob.$touch()"
                            ></b-form-input>
                            <b-input-group-append>
                              <b-form-datepicker
                                button-only
                                right
                                :max="max"
                                locale="es"
                                :date-format-options="{
                                  year: 'numeric',
                                  month: 'numeric',
                                  day: 'numeric',
                                }"
                                @focusin.native="$v.form.user.dob.$touch()"
                                @input="SetDateFormat"
                              ></b-form-datepicker>
                            </b-input-group-append>
                          </b-input-group>
                          <span class="error-input d-block">{{
                            validationMsgRegistro($v.form.user.dob)
                          }}</span>
                        </b-form-group>
                        <!-- Phone -->
                        <div class="d-flex flex-column">
                          <b-form-group label="Teléfono">
                            <div class="d-flex">
                              <b-form-input
                                type="tel"
                                id="input-telefono"
                              ></b-form-input>
                              <b-form-input
                                type="tel"
                                id="input-telefono"
                                v-model="form.user.phoneNumber"
                                required
                                v-bind:class="{
                                  error: $v.form.user.phoneNumber.$error,
                                }"
                                @blur="$v.form.user.phoneNumber.$touch()"
                              ></b-form-input>
                            </div>
                            <span class="error-input d-block">{{
                              validationMsgRegistro($v.form.user.phoneNumber)
                            }}</span>
                            <span
                              v-if="countryNotSupported"
                              class="error-input d-block"
                            >
                              We currently don't support registrations from this
                              country.
                            </span>
                          </b-form-group>
                        </div>
                      </b-col>
                      <b-col cols="12" md="5" class="mobile-credentials">
                        <div class="background-gray">
                          <b-form-group
                            id="input-email-title"
                            label="Correo electrónico"
                          >
                            <!-- <p>Correo electrónico</p> -->
                            <b-form-input
                              id="input-email"
                              type="email"
                              v-model="form.user.email"
                              required
                              v-bind:class="{
                                error: $v.form.user.email.$error,
                              }"
                              @blur="$v.form.user.email.$touch()"
                            ></b-form-input>
                            <span class="error-input d-block">{{
                              validationMsgRegistro($v.form.user.email)
                            }}</span>
                          </b-form-group>
                          <b-form-group
                            id="input-password-title"
                            label="Contraseña"
                          >
                            <!-- <p>Contraseña</p> -->
                            <b-icon
                              class="eye"
                              :icon="eyesPassword ? 'eye' : 'eye-slash'"
                              aria-hidden="true"
                              @click="eyesPassword = !eyesPassword"
                            ></b-icon>
                            <b-form-input
                              id="input-password"
                              :type="eyesPassword ? 'password' : 'text'"
                              v-model="form.user.password"
                              :placeholder="
                                eyesPassword
                                  ? '*********'
                                  : 'Ingrese la contraseña'
                              "
                              autocomplete="off"
                              required
                              v-bind:class="{
                                error: $v.form.user.password.$error,
                              }"
                              @blur="$v.form.user.password.$touch()"
                            ></b-form-input>
                            <span class="error-input d-block">{{
                              validationMsgRegistro($v.form.user.password)
                            }}</span>
                          </b-form-group>
                          <b-form-group
                            id="input-confirmPassword-title"
                            class="mb-0"
                            label="Repetir contraseña"
                          >
                            <!-- <p>Confirmar contraseña</p> -->
                            <b-icon
                              class="eye"
                              :icon="eyesConfirmPassword ? 'eye' : 'eye-slash'"
                              aria-hidden="true"
                              @click="
                                eyesConfirmPassword = !eyesConfirmPassword
                              "
                            ></b-icon>
                            <b-form-input
                              id="input-confirm-password"
                              :type="eyesConfirmPassword ? 'password' : 'text'"
                              v-model="form.user.confirmPassword"
                              :placeholder="
                                eyesConfirmPassword
                                  ? '*********'
                                  : 'Confirmar contraseña'
                              "
                              autocomplete="off"
                              required
                              v-bind:class="{
                                error: $v.form.user.confirmPassword.$error,
                              }"
                              @blur="$v.form.user.confirmPassword.$touch()"
                            ></b-form-input>
                            <span class="error-input d-block">{{
                              validationMsgRegistro(
                                $v.form.user.confirmPassword
                              )
                            }}</span>
                          </b-form-group>
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>

                <!-- Terms and conditions -->
                <b-row>
                  <b-col md="8">
                    <b-form-group class="terms">
                      <b-form-checkbox
                        name="checkbox-1"
                        value="true"
                        v-model="form.user.flagAcepted"
                        required
                        v-bind:class="{
                          error: $v.form.user.flagAcepted.$error,
                        }"
                        @blur="$v.form.user.flagAcepted.$touch()"
                      >
                        <p class="mb-0">
                          He leído los
                          <a
                            :href="pdf.PDF_TERMS"
                            target="_blank"
                            class="link blue"
                            style="font-size: 13px"
                            >Términos de Servicio</a
                          >
                          y
                          <b-link
                            class="link blue"
                            :href="pdf.PDF_POLICY"
                            target="_blank"
                            style="font-size: 13px"
                            >Política de Privacidad</b-link
                          >
                        </p>
                        <span class="error-input d-block">{{
                          validationMsgRegistro($v.form.user.flagAcepted)
                        }}</span>
                      </b-form-checkbox>
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-button
                      class="btn btn-primary m-auto w-auto d-block"
                      @click="procesarRegisterStudent"
                      :class="{ loading: isLoading }"
                      >Registrarme</b-button
                    >
                  </b-col>
                </b-row>
              </div>
            </div>
          </b-form>
        </div>
      </div>
      <div class="preUser-right">
        <img src="@/assets/img/login-background2.jpg" class="no_mb" />
        <p>
          Propiedad de English Advance SAC, 2021. <br class="no_desktop" />
          Todos los Derechos Reservados.
        </p>
      </div>
    </div>
    <b-toast
      id="toast-register-error"
      variant="none"
      no-close-button
      toaster="b-toaster-top-center"
    >
      <img
        src="@/assets/img/ico-equis.png"
        style="margin-right: 10px; margin-top: -2px"
      />
      {{ messageRegisterStudent }}
    </b-toast>
  </div>
  <!-- </div> -->
</template>
<script>
import "intl-tel-input/build/css/intlTelInput.css";
import intlTelInput from "intl-tel-input";
import { baseInstanceAxios } from "@/assets/js/axiosBase.js";
import {
  required,
  email,
  numeric,
  sameAs,
  minLength,
  maxLength,
} from "vuelidate/lib/validators";
import { validationMessage } from "vuelidate-messages";
import { getTimeZoneUser, getTimeZoneNameUser } from "@/assets/js/util.js";
// Map intl-tel-input country names → API country names when they differ.
const COUNTRY_NAME_OVERRIDES = {
  "North Macedonia": "Macedonia",
};
import axios from "axios";
import { IMAGENES, PDF } from "@/assets/js/appConstants";

const formRegisterMessages = {
  required: function () {
    return this.$t("validations.formRegisterMessages.required");
  },
  email: function () {
    return this.$t("validations.formRegisterMessages.email");
  },
  flagEmailEnUso: function () {
    return this.$t("validations.formRegisterMessages.flagEmailEnUso");
  },
  strongPassword: function () {
    return this.$t("validations.formRegisterMessages.strongPassword");
  },
  noWhitespacesPassword: function () {
    return this.$t("validations.formRegisterMessages.noWhitespacesPassword");
  },
  maxLengthPassword: function ({ $params }) {
    return this.$t("validations.formRegisterMessages.maxLengthPassword", {
      nro: $params.maxLengthPassword.max,
    });
  },
  sameAsPassword: function () {
    return this.$t("validations.formRegisterMessages.sameAsPassword");
  },
  minLength: function ({ $params }) {
    return this.$t("validations.formRegisterMessages.minLength", {
      nro: $params.minLength.min,
    });
  },
  maxLength: function ({ $params }) {
    return this.$t("validations.formRegisterMessages.maxLength", {
      nro: $params.maxLength.max,
    });
  },
  alphaWithSpaces: function () {
    return this.$t("validations.formRegisterMessages.alphaWithSpaces");
  },
  numeric: function () {
    return this.$t("validations.formRegisterMessages.numeric");
  },
  isValidDate: function () {
    return "Debe ingresar una fecha válida";
    //return this.$t('validations.formRegisterMessages.numeric') GH => Mover al Json
  },
  requiredTyC: () => "Debe aceptar los Términos y Condiciones",
};

export default {
  data() {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const maxDate = new Date(today);
    return {
      API_URL: process.env.VUE_APP_API_URL,
      iti: null,
      countryNotSupported: false,
      max: maxDate,
      form: {
        user: {
          firstName: "",
          lastName: "",
          email: "",
          password: "",
          confirmPassword: "",
          //extension_Phone: '',
          phoneNumber: "",
          countryId: null,
          city: "",
          address: "",
          dob: "",
          flagAcepted: false,
        },
        photo: null,
        optionsCountry: [],
      },
      pdf: PDF,
      urlPhoto: IMAGENES.PHOTO_STUDENT_DEFAULT,
      eyesPassword: true,
      eyesConfirmPassword: true,
      isLoading: false,
      messageRegisterStudent: "",
      flagEmailEnUso: false,
      flagUrl: process.env.VUE_FLAGS_URL,
      isResponsive: false,
    };
  },
  components: {},
  validations: {
    form: {
      user: {
        firstName: {
          required,
          minLength: minLength(2),
          maxLength: maxLength(50),
          alphaWithSpaces(value) {
            return /^[A-zÀ-ú\s]*$/.test(value); // condición no espacios en blanco
          },
        },
        lastName: {
          required,
          minLength: minLength(2),
          maxLength: maxLength(60),
          alphaWithSpaces(value) {
            return /^[A-zÀ-ú\s]*$/.test(value); // condición no espacios en blanco
          },
        },
        email: {
          required,
          email,
          flagEmailEnUso(value) {
            if (value === "" || !this.$v.form.user.email.email) return true;

            return new Promise((resolve, reject) => {
              return baseInstanceAxios
                .get(
                  this.API_URL +
                    `/resources/PersonsStudents/ExistsEmailByStudents?Email=${value}&Id=0&FlagStudent=true`
                )
                .then((response) => {
                  resolve(!response.data.return);
                })
                .catch((error) => {
                  reject(error);
                });
            });
          },
        },
        password: {
          required,
          maxLengthPassword: maxLength(20),
          strongPassword(password) {
            return (
              /[a-z]/.test(password) && // condición minúscula (a-z)
              /[A-Z]/.test(password) && // condición mayúscula  (A-Z)
              /[0-9]/.test(password) && // condición número (0-9)
              /\W|_/.test(password) && // condición símbolo
              password.length >= 6
            );
          },
          noWhitespacesPassword(password) {
            return !/["/ +/"]/.test(password); // condición no espacios en blanco
          },
        },
        confirmPassword: {
          required,
          sameAsPassword: sameAs("password"),
        },
        /*extension_Phone: {
                    required,
                    numeric,
                },*/
        phoneNumber: {
          required,
          numeric,
        },
        dob: {
          required,
          isValidDate(value) {
            let date = this.$moment(value, "DD/MM/YYYY");
            return date.isValid() && /^(\d{2}\/\d{2}\/\d{4})$/g.test(value);
          },
        },
        flagAcepted: {
          requiredTyC(value) {
            return value;
          },
        },
      },
    },
  },
  mounted() {
    localStorage.setItem("lang", "es");
    const input = document.querySelector("#input-telefono");
    this.iti = intlTelInput(input, {
      preferredCountries: ["PE", "US"],
      separateDialCode: true,
    });
    input.addEventListener("countrychange", this.onCountryChange);
    this.listCountries();
    window.innerWidth > 576
      ? (this.isResponsive = true)
      : (this.isResponsive = false);
  },
  methods: {
    syncCountryId() {
      if (!this.iti || !this.form.optionsCountry.length) return;
      const selectedCountryData = this.iti.getSelectedCountryData();
      const selectedIso = (selectedCountryData.iso2 || "").toUpperCase();
      const selectedName = selectedCountryData.name;
      if (!selectedIso && !selectedName) return;

      // Primary match: ISO country code (language-independent, robust).
      let found = selectedIso
        ? this.form.optionsCountry.find(
            (c) => (c.isoCode || "").toUpperCase() === selectedIso
          )
        : null;

      // Fallback for any list entry missing an ISO code: normalized name match.
      if (!found && selectedName) {
        const normalize = (s) =>
          s
            .replace(/\s*\(.*$/, "")
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .toLowerCase()
            .trim();
        const normalized = normalize(
          COUNTRY_NAME_OVERRIDES[selectedName] || selectedName
        );
        found = this.form.optionsCountry.find(
          (c) => normalize(c.descripcion) === normalized
        );
      }

      this.form.user.countryId = found ? found.id : null;
      this.countryNotSupported = !found;
    },
    onCountryChange() {
      this.syncCountryId();
    },
    validationMsgRegistro: validationMessage(formRegisterMessages),
    SetDateFormat: function (value) {
      let dateFormat = this.$moment(value, "YYYY-MM-DD").format("DD/MM/YYYY");
      this.form.user.dob = dateFormat;
    },
    procesarRegisterStudent: function () {
      //console.log(this.form.user);
      //this.flagEmailEnUso = false;
      if (!this.isLoading) {
        this.$v.$touch();
        if (this.$v.$invalid) {
          return;
        }
        this.registerStudent();
      }
    },
    listCountries() {
      baseInstanceAxios
        .get(
          this.API_URL + `/Resources/Countries/ListCountries?flagLenguage=true`
        )
        .then((response) => {
          if (response.data != null && response.data.list) {
            this.form.optionsCountry = response.data.list;
            this.syncCountryId();
          }
        });
    },
    handleFile: function (event) {
      for (var i = 0; i < event.target.files.length; i++) {
        const file = event.target.files[i];
        this.urlPhoto = URL.createObjectURL(file);
        this.form.photo = file;
        break;
      }
    },
    registerStudent() {
      this.isLoading = true;
      let dataPost = this.form.user;

      var dateMomentObject = this.$moment(dataPost.dob, "DD/MM/YYYY");
      dataPost.birthDate = dateMomentObject.toDate();
      dataPost.timeZoneInt = getTimeZoneUser();
      dataPost.timeZoneName = getTimeZoneNameUser();
      dataPost.userCreated = dataPost.email;

      const model = Object.freeze({
        FirstName: dataPost.firstName,
        LastName: dataPost.lastName,
        Email: dataPost.email,
        Password: dataPost.password,
        Extension_Phone: this.iti.selectedCountryData.dialCode,
        PhoneNumber: dataPost.phoneNumber,
        CountryId: dataPost.countryId,
        City: dataPost.city,
        Address: dataPost.address,
        BirthDate: dataPost.birthDate,
        TimeZoneInt: dataPost.timeZoneInt,
        UserCreated: dataPost.userCreated,
        TimeZoneName: Intl.DateTimeFormat().resolvedOptions().timeZone
          ? Intl.DateTimeFormat().resolvedOptions().timeZone
          : "America/Lima",
      });

      const formData = new FormData();
      formData.append("File", this.form.photo);
      //formData.append("Model", JSON.stringify(model));
      formData.append("ModelStr", JSON.stringify(model));

      axios({
        method: "POST",
        url: this.API_URL + `/Resources/PersonsStudents/Save`,
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then((response) => {
          if (response.data != null && response.data.return) {
            this.messageRegisterStudent = this.$t(
              "planesYPrecios.paso-5.titulo"
            );
            this.$bvToast.show("toast-register-error");
            this.limpiarForm();
            this.$router.replace({ name: "login" });
          } else {
            this.messageRegisterStudent = this.$t("register.text");
            this.$bvToast.show("toast-register-error");
          }
          this.isLoading = false;
        })
        .catch(function (error) {
          console.log(error);
          this.messageRegisterStudent = this.$t("register.text");
          this.$bvToast.show("toast-register-error");
          this.isLoading = false;
        });
    },
    limpiarForm() {
      this.form.user = {};
    },
    backStep() {
      this.$router.go(-1);
    },
  },
};
</script>
<style>
.custom-checkbox .custom-control-label::before {
  border-color: #b7b8bd;
}
.iti__flag {
  background-image: url("/images/flags.png");
}
/* .iti.iti--allow-dropdown input.form-control{
    padding-left: 72px !important;
} */
</style>
